import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
function Footer() {
  return (
    <footer className="footer">
      <h1>© 2022 Styclick</h1>
      <div className="product-arrivals social">
        <div>
          <FacebookIcon></FacebookIcon>
        </div>
        <div>
          <InstagramIcon></InstagramIcon>
        </div>{" "}
        <div>
          <LinkedInIcon></LinkedInIcon>
        </div>{" "}
        <div>
          <TwitterIcon></TwitterIcon>
        </div>
      </div>
      <style jsx>{`
        .footer {
          display: flex;
          background-color: #fefefe;
          justify-content: center;
          flex-direction: column;
          border-top: 1px solid black;
        }
        .product-arrivals {
          display: flex;
          padding: 1rem 0.5rem;
        }
        .product-arrivals div {
          flex: 25%;
          padding: 5px;
        }
        .product-arrivals div img {
          width: 100%;
        }

        .footer h1 {
          text-align: center;
          font-size: 1rem;
          margin-top: 1rem;
        }
        .social {
          display: flex;
          justify-content: center;
          margin-left: 25vw;
          flex-direction: row;
          flex: 25%;
        }
        @media screen and (max-width: 768px) {
          .social {
            flex-wrap: nowrap;
            /* margin-left: 10vw; */
            justify-content: center;
            /* margin: 0 1rem; */
            margin-right: 10vw;
          }
        }
      `}</style>
    </footer>
  );
}
export default Footer;
